<template>
  <div class="login-wrapper">
    <form-fail id="errors" :form-errors="apiErrors.other"/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import validationErrors from '../../common/form/validation-errors'
import formFail from '../../common/form/form-fail'

export default {
  components: {
    validationErrors,
    formFail
  },
  computed: {
    ...mapState('token/forms/login', [
      'apiErrors',
      'fields'
    ])
  },
  created () {
    this.removeChrome()
    this.clear()
    
    window.iiploginToken = (accessToken, refreshToken, url) => {
      const data = {
        redirectUrl: url,
        access_token: accessToken,
        refresh_token: refreshToken
      }

      this.loginWithTokens(data)

      return ''
    }

    window.iiplogin = (email, password, url) => {
      this.$store.commit('token/forms/login/setField', {
        field: 'email',
        value: email
      })
      this.$store.commit('token/forms/login/setField', {
        field: 'password',
        value: password
      })
      this.$store.commit('token/forms/login/setField', {
        field: 'redirectUrl',
        value: url
      })
      
      this.login()

      return ''
    }
  },
  
  methods: {
    ...mapActions({
      login: 'token/login',
      clear: 'token/clearAll',
      removeChrome: 'config/removeChrome',
      loginWithTokens: 'token/loginWithTokens'
    })
  }
}
</script>

<style lang="scss" scoped>
.login-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/auth/mlogin.vue